import { notificationSelectors, alertSelectors, authSelectors } from "../selectors";
import { globalService as gs, defaultService } from "../../services";

const notification = (method = "GET", params = null, params2 = null, key = null) => {
    return dispatch => {
        dispatch(notificationSelectors.start());
        defaultService.notification(method, params, params2)
            .then(response => {
                switch(method) {
                    case 'GET':
                        if(response.success) {
                            if(key !== null) {
                                dispatch(notificationSelectors.more(response.items));
                            } else {
                                dispatch(notificationSelectors.list(response));
                            }
                        }
                        break;
                    case 'POST':
                        if(response.success) {
                            dispatch(notificationSelectors.read(params.selection));
                            dispatch(alertSelectors.success(response.message));
                        }
                        break;
                    case 'DELETE':
                        dispatch(notificationSelectors.remove(params.selection));
                        dispatch(alertSelectors.success(response.message));
                        break;
                    default:
                }
                dispatch(notificationSelectors.stop());
            })
            .catch(exception => {
                gs.showErrors(dispatch, exception, alertSelectors);
                dispatch(notificationSelectors.stop());
            });
        };
};

const removeCount = (authentication) => {
    return dispatch => {
        let response = authentication;
        response.user.userProfile.notifications = 0;
        gs.storeItem('authentication', response);
        dispatch(authSelectors.success(response));
    }
}

const clear = () => {
    return dispatch => {
        dispatch(notificationSelectors.clear());
    };
};

export const notificationActions = {
    notification,
    removeCount,
    clear
};